module.exports = __webpack_public_path__ + "static/media/address-empty.13f85bf3.png";